declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    mdx: true;
  }
}

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    mdx: 1024,
    lg: 1200,
    xl: 1536,
  },
};

export default breakpoints;
